import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";

const quickLinks = [
  { to: "/", label: "Home", testid: "footer-link-home" },
  { to: "/about", label: "About Us", testid: "footer-link-about" },
  { to: "/services", label: "Services", testid: "footer-link-services" },
  { to: "/contact", label: "Contact Us", testid: "footer-link-contact" },
];

const legalLinks = [
  { to: "/terms", label: "Terms of Service", testid: "footer-link-terms" },
  { to: "/cancellation-refund-policy", label: "Cancellation & Refunds", testid: "footer-link-refund" },
  { to: "/privacy-policy", label: "Privacy Policy", testid: "footer-link-privacy" },
];

export const Footer = () => (
  <footer className="bg-brand-950 text-white" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
      <div>
        <Link to="/" className="flex items-center gap-3" data-testid="footer-logo-link" aria-label="Chatbudds home">
          <img src="/logo.png" alt="Chatbudds logo" className="h-10 w-10 rounded-lg ring-1 ring-white/20" />
          <span className="font-display text-xl font-bold tracking-tight">
            chat<span className="text-brand-300">budds</span>
          </span>
        </Link>
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-brand-100/70">
          We turn ad spend into predictable growth. Meta Ads and Google Ads, run with honest strategy and transparent reporting.
        </p>
        <Link
          to="/contact"
          data-testid="footer-cta-button"
          className="group mt-6 inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-brand-800 transition-colors duration-300 hover:bg-brand-100 active:scale-95"
        >
          Get a Free Strategy Call
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>

      <div>
        <h3 className="text-xs font-semibold uppercase tracking-widest text-brand-300">Quick links</h3>
        <ul className="mt-5 space-y-3">
          {quickLinks.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={l.testid}
                className="text-sm text-brand-100/80 transition-colors duration-300 hover:text-white"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="text-xs font-semibold uppercase tracking-widest text-brand-300">Legal</h3>
        <ul className="mt-5 space-y-3">
          {legalLinks.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={l.testid}
                className="text-sm text-brand-100/80 transition-colors duration-300 hover:text-white"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="text-xs font-semibold uppercase tracking-widest text-brand-300">Get in touch</h3>
        <ul className="mt-5 space-y-4 text-sm text-brand-100/80">
          <li className="flex items-start gap-3">
            <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand-300" />
            <a href="mailto:chatbudds2@gmail.com" data-testid="footer-email-link" className="transition-colors hover:text-white">
              chatbudds2@gmail.com
            </a>
          </li>
          <li className="flex items-start gap-3">
            <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand-300" />
            <a href="tel:+918448444896" data-testid="footer-phone-link" className="transition-colors hover:text-white">
              +91 84484 44896
            </a>
          </li>
          <li className="flex items-start gap-3">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-300" />
            <span data-testid="footer-address">747, Niti Khand -1, Indirapuram, Ghaziabad</span>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
        <p className="text-xs text-brand-100/50">© {new Date().getFullYear()} Chatbudds. All rights reserved.</p>
        <p className="text-xs text-brand-100/50">Performance marketing, accountable to your numbers.</p>
      </div>
    </div>
  </footer>
);
